import { render } from "./SpacesInvitations.vue?vue&type=template&id=7ee92e5c&scoped=true&ts=true"
import script from "./SpacesInvitations.vue?vue&type=script&lang=ts"
export * from "./SpacesInvitations.vue?vue&type=script&lang=ts"

import "./SpacesInvitations.vue?vue&type=style&index=0&id=7ee92e5c&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee92e5c"]])

export default __exports__